import styles from "./Booking.css";
import moment from "moment";
import axios from "axios";
import { Modal, Box } from "@material-ui/core";
import { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { CovertString_TO_DateFormat } from "../../utils";
import { makeStyles } from "@material-ui/core/styles";
import "../../App.css";
import Googleplay from "./image/Googleplay.png";
import Applestore from "./image/appdownloads.png";


import FloatingLabelInput from "./BookingForm/FloatingLabelInput";
import FloatingLabelSelect from "./BookingForm/FloatingLabelSelect";
import './BookingForm/PartyForm.css';
import './BookingForm/Feed.css'
import './BookingForm/FloatingLabelInput.css';
import './BookingForm/FloatingLabelSelect.css';

import Rectangle from "./image/Rectangle.png"
import feed1 from "./image/feed-1.png"
import feed2 from "./image/feed-2.png"
import feed3 from "./image/feed-3.png"
import feed from "./image/feed.jpg"


import iziToast from "izitoast";
import Loader from "../../Loader/Loader";
import Loginpopup from "../../Navbar/Loginmodal";




const useStyles12 = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

const inputStyle = {
  width: "110px",
  padding: "0.5em",
  border: "none",
  background: "#1e1434",
  borderRadius: "5px",
  boxSizing: "border-box",
  marginBottom: "10px",
};

const selectStyle = {
  width: "180px",
  padding: "0.9em",
  borderRadius: "5px",
  background: "#1e1434",
  color: "rgb(180, 180, 180)",
  fontSize: "12px",
};

const useStyles = makeStyles({
  root: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#B40431",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#B40431",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#B40431",
    },
    "& .MuiOutlinedInput-input": {
      color: "white",
    },
    "&:hover .MuiOutlinedInput-input": {
      color: "white",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "white",
    },
    "& .MuiInputLabel-outlined": {
      color: "white",
    },
    "&:hover .MuiInputLabel-outlined": {
      color: "white",
    },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: "white",
    },
  },
});
const useStyles1 = makeStyles({
  root: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "& .MuiOutlinedInput-input": {
      color: "white",
    },
    "&:hover .MuiOutlinedInput-input": {
      color: "white",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "white",
    },
    "& .MuiInputLabel-outlined": {
      color: "white",
    },
    "&:hover .MuiInputLabel-outlined": {
      color: "white",
    },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: "white",
    },
  },
});

function TableBookingForm({ clubId }) {
  const [remainingDates, setRemainingDates] = useState([]);
  const [timeIntervals, setTimeIntervals] = useState([]);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [apiData, setApiData] = useState(null);
  const [cityId, setCityId] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [open1, setOpen1] = useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);
  const [bookdata, setBookData] = useState([]);
  const classes = useStyles();
  const classes1 = useStyles1();
  const classes12 = useStyles12();
  const [cities, setCities] = useState([]);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState(null);
  const [citydata, setCityData] = useState([]);
  const [selectedAreaid, setSelectedAreaid] = useState(null);
  const [location12, setLocation12] = useState(""); // Location state
  const [leadarea, setLeadarea] = useState([]);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [isTextFieldOpen, setIsTextFieldOpen] = useState(false);


  const [userdata, setUserData] = useState(JSON.parse(localStorage.getItem("userData")));

  const handleTextFieldClick = () => {
    setIsTextFieldOpen(true);
  };
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedVenu, setSelectedVenu] = useState([]);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedPax, setSelectedPax] = useState(null);
  const [isReserved, setReserved] = useState(false);
  const [cancel, setCancel] = useState(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const status = searchParams.get("status");
  const formattedDate = moment(selectedDate).format("YYYY-MM-DD");

  const url = "https://partywitty.com/master/assets/uploads/";

  useEffect(() => {
    if (status === "success" && !isReserved) {
      setReserved(true);
    }
  }, [status, isReserved]);

  useEffect(() => {
    if (status === "failed" && !cancel) {
      setCancel(true);
    }
  }, [status, cancel]);

  // const handleTimeSelection = (time) => {
  //   setSelectedTime(time);
  // };

  const handleAreaChange = (e) => {
    const selectedAreaId = e.target.value;
    const areaData = leadarea.find((area) => area.id === selectedAreaId);

    setSelectedArea(areaData);
    setSelectedAreaid(areaData.id);
  };

  const venueTypeIds = selectedVenu.map((venue) => venue.id).join(",");

  useEffect(() => {
    setFormData((prevState) => ({
      ...prevState,
      club_id: clubId,
      city_id: cityId,
      area_id: selectedArea ? selectedArea.id : null,
      party_date: formattedDate,
      party_time: selectedTime,
      user_id: userdata ? userdata.id : "",
      venue_type: venueTypeIds,
      whatsapp: userdata ? userdata.whatsapp : null,
    }));
  }, [clubId, cityId, selectedArea, selectedTime, selectedVenu, formattedDate]);

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    club_id: clubId,
    whatsapp: userdata ? userdata.whatsapp : null,
    whatsapp_msg: "true",
    city_id: cityId,
    area_id: selectedArea ? selectedArea.id : "",
    male: "0",
    female: "0",
    kids: "0",
    party_date: formattedDate,
    party_time: selectedTime,
    lead_source: "website",
    user_id: userdata ? userdata.id : "",
    venue_type: venueTypeIds,
  });

  useEffect(() => {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();
    const lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    today.setHours(0, 0, 0, 0);
    const initialStartTime = moment(startTime, "h:mm A").toDate();
    const initialEndTime = moment(endTime, "h:mm A").toDate();
    initialStartTime.setMinutes(
      Math.ceil(initialStartTime.getMinutes() / 30) * 30
    );
    const intervals = [];
    const remainingDates = [];
    for (let i = 0; i < 3; i++) {
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth();
      const lastDayOfMonth = new Date(
        currentYear,
        currentMonth + 1,
        0
      ).getDate();
      for (let j = today.getDate(); j <= lastDayOfMonth; j++) {
        const date = new Date(currentYear, currentMonth, j);
        remainingDates.push(date);
      }
      today.setMonth(currentMonth + 1);
      today.setDate(1);
    }
    while (initialStartTime <= initialEndTime) {
      const formattedTime = moment(initialStartTime).format("HH:mm");
      intervals.push(formattedTime);
      initialStartTime.setMinutes(initialStartTime.getMinutes() + 30);
    }
    setTimeIntervals(intervals);
    setRemainingDates(remainingDates);
  }, [startTime, endTime]);



  useEffect(() => { }, [startTime, endTime]);

  const [doSubmit, setDoSubmit] = useState(false);


  useEffect(() => {
    if (doSubmit && userdata.id) {
      console.log('Submit Lead: ', doSubmit, userdata);
      handleSubmit();
      setDoSubmit(false);
    }
  }, [doSubmit,]);



  const handleSubmit = async (e) => {


    e?.preventDefault();

    const formDataObj = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formDataObj.append(key, value ?? ''); // Avoid null/undefined
    });

    if (!formData.party_date) {
      // toast.error("Please select a party date");
      iziToast.error({
        title: 'Error',
        message: 'Please select a party date',
        position: 'topRight',
        timeout: 3000,
      });
      return;
    }

    if (!formData.party_time) {
      // toast.error("Please select a party time");
      iziToast.error({
        title: 'Error',
        message: 'Please select a party time',
        position: 'topRight',
        timeout: 3000,
      });
      return;
    }

    if (formData.male === "" || formData.male < 0) {
      // toast.error("Enter a valid number of male guests");
      iziToast.error({
        title: 'Error',
        message: 'Enter a valid number of male guests',
        position: 'topRight',
        timeout: 3000,
      });
      return;
    }

    if (formData.female === "" || formData.female < 0) {
      iziToast.error({
        title: 'Error',
        message: 'Enter a valid number of female guests',
        position: 'topRight',
        timeout: 3000,
      });
      // toast.error("Enter a valid number of female guests");
      return;
    }

    if (formData.kids === "" || formData.kids < 0) {
      // toast.error("Enter a valid number of kids");
      iziToast.error({
        title: 'Error',
        message: 'Enter a valid number of kids',
        position: 'topRight',
        timeout: 3000,
      });
      return;
    }

    if (!formData.city_id || formData.city === "Select a city") {
      // toast.error("Please select a city");
      iziToast.error({
        title: 'Error',
        message: 'Please select a city',
        position: 'topRight',
        timeout: 3000,
      });
      return;
    }

    if (!selectedArea?.id) {
      // toast.error("Please select an area");
      iziToast.error({
        title: 'Error',
        message: 'Please select an area',
        position: 'topRight',
        timeout: 3000,
      });
      return;
    }



    const isAgreed = document.getElementById('agreeCheckbox').checked;

    if (!isAgreed) {
      // alert("You have accepted our terms and conditions");
      iziToast.error({
        title: 'Error',
        message: 'You have accepted our terms and conditions',
        position: 'topRight',
        timeout: 3000,
      });
      return;
    }

    if (userdata === null) {
      setShowLoginPopup(true);
      return false;
    } else {
      setShowLoginPopup(false);
    }



    setLoading(true);

    try {
      const response = await axios.post(
        "https://partywitty.com/master/APIs/ClubTable/submitEnquiry",
        formDataObj
      );

      if (response.data.status === true) {
        setFormData({
          club_id: clubId,
          whatsapp: userdata ? userdata.whatsapp : null,
          whatsapp_msg: "true",
          city_id: "",
          area_id: "",
          male: "",
          female: "",
          kids: "",
          party_date: null,
          party_time: null,
          lead_source: "website",
          user_id: userdata ? userdata.id : "",
          venue_type: venueTypeIds,
        });
        // alert("Form submitted successfully");
        iziToast.success({
          title: 'Success',
          message: 'Form submitted successfully',
          position: 'topRight',
          timeout: 3000,
        })
        setShowPopup(true);
        window.location.href = '/table-booking-submitted';
        document.getElementById('agreeCheckbox').checked = false;
      } else {
        // alert(response.data.msg);
        iziToast.error({
          title: 'Error',
          message: `${response.data.msg}`,
          position: 'topRight',
          timeout: 3000,
        });
        window.location.reload();
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleLogin = async (ud) => {
    if (ud) {
      setFormData((prevState) => ({
        ...prevState,
        user_id: ud.id,
        whatsapp: ud.whatsapp,
      }));
      setUserData(ud);
      setShowLoginPopup(false);

      // attempt to submit the form again
      setDoSubmit(true);
    }
  }


  const handlePopupClose = () => {
    setShowPopup(false);
  };
  const [clubcategorydata, setClubcategorydata] = useState([]);

  useEffect(() => {
    axios
      .get("https://partywitty.com/master/APIs/ClubPackage/getVenuType")
      .then((response) => {
        const clubCategories = response.data.data;
        setClubcategorydata(clubCategories);
        setSelectedVenu(clubCategories);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    const apiUrl = "https://partywitty.com/master/Api/getDataPost/AreaLead";
    if (cityId) {
      const formData = new FormData();
      formData.append("city_id", cityId);
      axios
        .post(apiUrl, formData)
        .then((response) => {
          setLeadarea(response.data.data);
        })
        .catch((error) => {
          console.error("API error:", error);
        });
    }
  }, [cityId]);

  useEffect(() => {
    axios
      .get("https://partywitty.com/master/Api/getData/getAreaLead")
      .then((response) => {
        setCityData(response.data.data);
      })
      .catch((error) => {
        console.log("Error fetching area data:", error);
      });
  }, []);

  useEffect(() => {
    const firstApiUrl =
      "https://partywitty.com/master/Api/getDataPost/countryWiseState";
    const formData = new FormData();
    formData.append("country_id", "101");
    const combinedData = [];
    axios
      .post(firstApiUrl, formData)
      .then((response) => {
        const stateIds = response.data.data
          .filter(
            (item) =>
              item.id === "4007" || item.id === "4021" || item.id === "4022"
          )
          .map((item) => item.id);
        const secondApiUrl =
          "https://partywitty.com/master/Api/getDataPost/stateWiseCity";
        const secondPostPromises = stateIds.map((stateId) => {
          const formData = new FormData();
          formData.append("state_id", stateId);
          return axios.post(secondApiUrl, formData);
        });
        return Promise.all(secondPostPromises);
      })
      .then((responses) => {
        responses.forEach((response) => {
          combinedData.push(...Array.from(response.data.data));
        });
        const filteredData = combinedData.filter((item) =>
          [
            "134404",
            "134007",
            "133234",
            "131821",
            "58171",
            "132032",
            "131853",
            "133230",
            "132005",
            "131953",
          ].includes(item.id)
        );
        setApiData(filteredData);
      })
      .catch((error) => {
        console.error("API error", error);
      });
  }, []);
  const handleVenueSelection = (venue) => {
    const isVenueSelected = selectedVenu.find((v) => v.id === venue.id);
    if (isVenueSelected) {
      setSelectedVenu((prevSelectedVenu) =>
        prevSelectedVenu.filter((v) => v.id !== venue.id)
      );
    } else {
      setSelectedVenu((prevSelectedVenu) => [...prevSelectedVenu, venue]);
    }
  };
  const handleLocationChange = (e) => {
    const selectedLocation = e.target.value;
    setLocation12(selectedLocation);
    const selectedCity = apiData.find((e) => e.name === selectedLocation);
    if (selectedCity) {
      setCityId(selectedCity.id);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const [selectedVenues, setSelectedVenues] = useState([]);

  const handleDateSelection = (data, type) => {
    if (type === "date") {
      const isAlreadySelected = selectedVenues.some(
        (venue) => venue.id === data.id
      );
      if (isAlreadySelected) {
        setSelectedVenues((prevVenues) =>
          prevVenues.filter((venue) => venue.id !== data.id)
        );
      } else {
        setSelectedVenues((prevVenues) => [...prevVenues, data]);
      }
    } else {
    }
  };

  const [activeTab, setActiveTab] = useState("table");
  const handleDateChange = (e) => {
    const selected = e.target.value;
    const today = new Date().toISOString().split("T")[0];

    if (selected < today) {
      alert("Past dates are not allowed.");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      party_date: selected,
    }));

    setSelectedDate(selected);
    handleDateSelection(selected, "date");
  };


  const handleTimeSelection = (e) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
    setSelectedTime(value);
  };



  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };





  const GroupParty = (
    <div className="pplf-form-container">
      <form onSubmit={handleSubmit} className="party-form">
        <FloatingLabelInput
          type="date"
          name="party_date"
          label="Party Date"
          value={formData.party_date}
          onChange={handleDateChange}
          min={new Date().toISOString().split("T")[0]}
        // required
        />


        <FloatingLabelInput
          type="time"
          name="party_time"
          label="Party Time"
          value={formData.party_time}
          onChange={handleTimeSelection}
        // required
        />


        <div>


          <div className="guest-group">
            <div className="guest-g-input">

              <FloatingLabelInput
                type="number"
                name="male"
                label="Male Guests"
                value={formData.male}
                onChange={handleInputChange}
                // required
                min="0"
                defaultValue={0}
              />
              <span className="small-text-form">21years and above</span>
            </div>

            <div>
              <FloatingLabelInput
                type="number"
                name="female"
                value={formData.female}
                label="Female Guests"
                onChange={handleInputChange}
                defaultValue={0}
                // required
                min="0"
              />
              <span className="small-text-form">21years and above</span>
            </div>

          </div>
        </div>


        <div>
          <FloatingLabelInput
            type="number"
            name="kids"
            label="Kids"
            value={formData.kids}
            onChange={handleInputChange}
            defaultValue={0}
            // required
            min="0"
          />
          <span className="small-text-form">5 years & below</span>
        </div>


        {/* <span className='small-text-form'>5 years & below</span> */}

        <div className="dropdown-group">
          <FloatingLabelSelect
            label="City"
            name="city"
            value={formData.city}
            onChange={handleLocationChange}
            options={[
              { id: "", name: "Select a city" }, // placeholder option
              ...citydata
            ]}
            valueKey="name"
          />


          <FloatingLabelSelect
            name="area"
            label="Area"
            value={selectedArea ? selectedArea.id : ""}
            onChange={handleAreaChange}
            options={[{ id: "", name: "Select a area" }, ...leadarea]}
            valueKey="id"
          />
        </div>

        <div>
          <FloatingLabelInput
            type="textarea"
            name="instructions"
            label="Please type here"
            value={formData.instructions}
            onChange={handleChange}
          />
          <div className="checkbox">
            <input
              type="checkbox"
              id="agreeCheckbox" // ✅ add an ID
              name="agree"
              checked={formData.agree}
              onChange={handleChange}
            />

            <span>
              I agree to the  <Link to="/privacy-policy">Privacy Policy</Link> and{' '}
              <Link to="/term-conditions-policy">Terms & Condition</Link>.
            </span>
          </div>
        </div>


        <button type="submit">Reserve Now</button>
      </form>

      {/* Success Modal */}
      <Modal
        open={showPopup}
        onClose={() => {
          setShowPopup(false);
          window.location.href = '/';
        }}
      >
        <div className="modal-container">
          <div className="modal-content">
            <button
              className="modal-button"
              onClick={() => {
                setShowPopup(false);
                window.location.href = '/';
              }}
            >
              x
            </button>
            <dotlottie-player
              src="https://lottie.host/6b9fc96a-5c59-464a-ad26-5782e3a54022/EFWiS28KVM.json"
              background="transparent"
              speed="1"
              style={{ height: "300px" }}
              loop
              autoplay
            ></dotlottie-player>
            <p className="modal-message">Form submitted successfully!</p>
            <div className="about-us-playstore-image">
              <Link to="https://play.google.com/store/apps/details?id=com.party.partywitty_guest">
                <img src={Googleplay} alt="playstore" />
              </Link>
              <Link to="https://play.google.com/store/apps/details?id=com.party.partywitty_guest">
                <img src={Applestore} alt="appstore" />
              </Link>
            </div>
          </div>
        </div>
      </Modal>
    </div>

  )


  return (
    <div className="Package-lead-page-container">
      {loading && <Loader />}
      {showLoginPopup && <Loginpopup clbk={handleLogin} />}

      <div className={styles.Container}>

        <div className="feed-section-container">
          <div className="feed-section-container-sec-nav">

          </div>
          <div className='feed-section'>
            <div className='feed-section-img'>
              <div className="feed-img-section">
                <img src="https://images.unsplash.com/photo-1575390130709-7b5fee2919e4?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="" />
                <div className='feed-img-overlay'>
                  <h1>Party Planning <span className='feed-img-overlay-span'>Just Got Smarter</span></h1>
                  <div className='feed-img-overlay-list'>
                    <div className='custom-image-list'>
                      <div className='custom-image'><img src={Rectangle} alt="" /> </div>
                      <span>Post your party plan</span>
                    </div>
                    <div className='custom-image-list'>
                      <div className='custom-image'><img src={Rectangle} alt="" /> </div>
                      <span>Let Venues Bid to Host it</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='feed-form-section'>
              <div className="tabs-sec-nav">
                <Link to='/package-lead-form'>
                  <div
                    className={`tabs-sec-nav-box ${activeTab === "package" ? "active" : ""}`}
                    onClick={() => setActiveTab("package")}
                  >
                    <h1>Party Package</h1>
                  </div>
                </Link>

                <Link to='/table-book-form'>
                  <div
                    className={`tabs-sec-nav-box ${activeTab === "table" ? "active" : ""}`}
                    onClick={() => setActiveTab("table")}
                  >
                    <h1>Table Reservation</h1>
                  </div>
                </Link>
              </div>



              <h2>Tell Us When Is The Party</h2>
              <div >
                {GroupParty}
              </div>
            </div>
          </div>
          <div>
            <div className='container'>
              <div className='f-feed'>
                <div className='f-feed-line'>
                  <div className='f-feed-text'>
                    <h1>1000+</h1>
                    <p>Clubs </p>
                  </div>
                  <div className='f-feed-img'>
                    <img src={feed1} alt="" />
                  </div>
                </div>
                <div className='v-line'></div>
                <div className='f-feed-line'>
                  <div className='f-feed-text'>
                    <h1>5,000 +</h1>
                    <p>F&B Packages </p>
                  </div>
                  <div className='f-feed-img'>
                    <img src={feed2} alt="" />
                  </div>
                </div>
                <div className='v-line'></div>

                <div className='f-feed-line'>
                  <div className='f-feed-text'>
                    <h1>12,000 +</h1>
                    <p>Happy Customers </p>
                  </div>
                  <div className='f-feed-img'>
                    <img src={feed3} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        {/* <div className="sticky-container">
        <div className="reserve--table--booking--card">
          <>

          {GroupParty}
            <Modal open={showPopup} onClose={() => setShowPopup(false)}>
              <div className="modal-container">
                <div className="modal-content">
                  <button
                    className="modal-button"
                    onClick={() => setShowPopup(false)}
                  >
                    x
                  </button>
                  <dotlottie-player
                    src="https://lottie.host/6b9fc96a-5c59-464a-ad26-5782e3a54022/EFWiS28KVM.json"
                    background="transparent"
                    speed="1"
                    style={{ height: "300px" }}
                    loop
                    autoplay
                  ></dotlottie-player>

                  <p className="modal-message">Form submitted successfully!</p>
                  <div className="about-us-playstore-image">
                    <Link to="https://play.google.com/store/apps/details?id=com.party.partywitty_guest">
                      <img src={Googleplay} alt="playstore" />
                    </Link>
                    <Link to="https://play.google.com/store/apps/details?id=com.party.partywitty_guest">
                      <img src={Applestore} alt="appstore" />
                    </Link>
                  </div>
                </div>
              </div>
            </Modal>
          </>
        </div>
      </div> */}
      </div>
    </div>
  );
}

export default TableBookingForm;

export const OfferDetailsData = [
  {
    id: 0,
    name: "product name",
    discount: "50%",
    offering_price: 14.25,
    originalPrice: 15.0,
    imgsrc: "/images/product1.svg",
  },
  {
    id: 1,
    name: "product name2",
    discount: "50%",
    offering_price: 16.25,
    originalPrice: 19.0,
    imgsrc: "/images/product2.svg",
  },
];

export const ClubTiming = [
  "03:00",
  "04:00",
  "05:00",
  "06:00",
  "07:00",
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
  "20:00",
  "21:00",
  "22:00",
  "23:00",
  "00:00",
];
